import {NavLink} from "react-router-dom";
import React from "react";

const MainNav = () => (
  <div className="navbar-nav mr-auto">
    <NavLink
      to="/"
      exact
      className="nav-link"
      activeClassName="router-link-exact-active"
    >
      Home
    </NavLink>
    <NavLink
      to="/tokens"
      exact
      className="nav-link"
      activeClassName="router-link-exact-active"
    >
      Tokens
    </NavLink>
    <NavLink
      to="/external-api"
      exact
      className="nav-link"
      activeClassName="router-link-exact-active"
    >
      Create new org
    </NavLink>
    <NavLink
      to="/invite-users"
      exact
      className="nav-link"
      activeClassName="router-link-exact-active"
    >
      Invite Users
    </NavLink>
  </div>
);

export default MainNav;
